import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges} from '@angular/core';
import {TypedSimpleChanges} from '../../../../common/typed-on-changes';
import {DynDisplayAsset} from '../dyn-wallet-row';

@Component({
    selector:        'dyn-display-asset',
    templateUrl:     './dyn-display-asset.component.html',
    styleUrls:       ['./dyn-display-asset.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynDisplayAssetComponent implements OnChanges {

    @Input()
    public displayAsset: DynDisplayAsset;

    @Input()
    public hideIcon: boolean = false;

    constructor(
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngOnChanges(changes: TypedSimpleChanges<DynDisplayAssetComponent>): void {
        if (changes.displayAsset) {
            this.changeDetectorRef.markForCheck();
        }
    }

}
